"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M12 6.38 17.88 10 19 8.37 12 4 5 8.37 6.12 10 12 6.38z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.09 10.84c-.6-.56-1.55-.84-2.85-.84H9v10h2.14v-3.56h.92c.98 0 1.76-.15 2.33-.46.58-.31.99-.71 1.24-1.22s.37-1.06.37-1.64c0-.97-.3-1.73-.91-2.28zm-1.8 3.52c-.35.23-.83.35-1.43.35h-.72v-2.97h.98c1.14 0 1.7.49 1.7 1.46.01.53-.17.91-.53 1.16z"
  })];
};

exports.default = _default;